module.exports = __webpack_public_path__ + "img/Vector26.6326daa2.svg";